<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

  export default {
    name: 'app',
    mounted () {
      // this.$router.replace({ name: 'login' })
    },
    created () {}
  }
</script>

<style lang="scss">

  /* 自定义的通用样式库，注意先在style加上 lang="scss"，全局引用 */
  @import './stylesheets/common.scss';
  .ivu-message-error {
    max-width: 920px
  }

  /* TODO: 这里的 text-align: center; 值得商榷（魏宏裕）*/
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "San Francisco Pro", "San Francisco", Roboto, "IBM Plex Sans", "Helvetica Neue", Helvetica, Verdana, Tahoma, Arial, "Microsoft Yahei UI", "Microsoft Yahei", "PingFang SC", "Noto Sans CJK SC", "Source Han Sans SC", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    /*margin-top: 60px;*/
  }
</style>
